import page from "@homer.core/page";
import StorageLocal from "@homer.core/storage.local";
import isUndefined from "@homer.utility/validator.isundefined";
import application from "@homer.core/application";
import { name } from "../package.json";

const excludedTypes = ["cart", "checkout", "checkoutConfirmation"];
const storageLocal = new StorageLocal(name, { version: application.version, lifetime: 30 * 24 * 60 * 60 });
const entry = JSON.parse(storageLocal.get() || `{"time":null,"url":null,"referrer":null}`);

const referrer = (page.referrer && new URL(page.referrer)) || null;
const hasExternalReferrer = !!(referrer && referrer.isLocal === false);
const isRelevantEntry = (() => {
    // excluded page types should never set entry/referrer
    if (excludedTypes.includes(page.type)) {
        return false;
    }

    // pages with "auth" parameters should also be excluded
    if (referrer && !isUndefined(referrer.parameter.auth)) {
        return false;
    }

    // presence of an external referrer should always set entry/referrer
    if (hasExternalReferrer) {
        return true;
    }

    // otherwise only set entry when not already set
    return !entry.url;
})();

class Entry {
    constructor() {
        if (isRelevantEntry) {
            this.set();
        }

        Object.defineProperties(this, {
            time: { get: () => entry.time, enumerable: true },
            url: { get: () => entry.url, enumerable: true },
            referrer: { get: () => entry.referrer, enumerable: true },
        });
    }

    set() {
        entry.time = +new Date();
        entry.url = page.url;
        entry.referrer = hasExternalReferrer ? page.referrer : null;

        storageLocal.set(JSON.stringify(entry));
    }

    reset() {
        entry.time = entry.url = entry.referrer = null;

        storageLocal.set(JSON.stringify(entry));
    }
}

export default new Entry();
